import { defaultCtx } from "~/lib/AjaxCtx"

export default class TntService {
    constructor(ctx) {
        this.$http = ctx || defaultCtx
    }
    /**
     * Returns the updated activity state.
     */
    async publish(userActivityId) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/publish`,
            {
                method: "POST",
            }
        )
    }

    /**
     * Doesn't return anything.
     */
    async deleteFile(userActivityId, idFile) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/removeFile`,
            {
                method: "POST",
                body: JSON.stringify({ idFile }),
            }
        )
    }

    /**
     * Doesn't return anything.
     */
    async deleteVersion(userActivityId, idVersion) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/removeVersion`,
            {
                method: "POST",
                body: JSON.stringify({ idVersion }),
            }
        )
    }

    /**
     * Returns the new file.
     */
    async addFile(userActivityId, fileName, fileHash) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/addFile`,
            {
                method: "POST",
                body: JSON.stringify({ fileName, fileHash }),
            }
        )
    }

    /**
     * Returns the new version.
     */
    async addVersion(userActivityId, idFile, fileName, fileHash) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/addVersion`,
            {
                method: "POST",
                body: JSON.stringify({ idFile, fileName, fileHash }),
            }
        )
    }

    /**
     * Returns the new comment.
     */
    async sendComment(userActivityId, idVersion, comment) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/addComment`,
            {
                method: "POST",
                body: JSON.stringify({ idVersion, comment }),
            }
        )
    }

    /**
     * Returns a file descriptor.
     */
    async uploadFile(file, progressCallback) {
        return await this.$http.uploadFile(file, progressCallback)
    }
}
